import { Reducer } from 'redux';
import { INITIAL_PROMOTION_STATE } from '../../constants';
import { OFFLINE_PROMOTIONS_CHANGED, PromotionActions } from '../actions/promotionActions';
import { IPromotionState } from '../types';

export const promotionReducer: Reducer<IPromotionState, PromotionActions> = (
    state = INITIAL_PROMOTION_STATE,
    action
): IPromotionState => {
    switch (action.type) {
        case OFFLINE_PROMOTIONS_CHANGED:
            return { ...state, offlinePromotions: action.payload };
        default:
            return state;
    }
};
